module.exports = __webpack_public_path__ + "img/place-order-katapult.deb5fa8.svg";